import { useState, useEffect } from "react";
import { DialogModal } from "../ui/dialogModal";
import { Textarea } from "../ui/input";

// Comment-required modal used by both RM→Employee and HR→RM send-back flows.
const SendBackModal = ({ open, onClose, onConfirm, title = "Send Back", actor = "RM" }) => {
    const [comment, setComment] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (open) {
            setComment("");
            setError("");
        }
    }, [open]);

    const handleSave = () => {
        if (!comment.trim()) {
            setError("A reason is required when sending back.");
            return;
        }
        onConfirm?.(comment.trim());
    };

    return (
        <DialogModal
            open={open}
            onClose={onClose}
            onSave={handleSave}
            title={title}
            saveLabel="Send Back"
            saveButtonColor="destructive"
            width="500px"
            maxWidth="95vw"
        >
            <div className="space-y-3">
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    Please describe what needs to be corrected. This comment will be shared with the {actor === "RM" ? "employee" : "reporting manager"} and recorded in the audit history.
                </p>
                <Textarea
                    value={comment}
                    onChange={(e) => { setComment(e.target.value); if (error) setError(""); }}
                    rows={5}
                    maxLength={500}
                    showCharCount
                    placeholder="Reason for send back..."
                />
                {error && <p className="text-xs text-red-500">{error}</p>}
            </div>
        </DialogModal>
    );
};

export default SendBackModal;
